/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'

import { baseUrl } from '../../../constant/constant'

import { CreatableSelectComponent } from '../../SelectDropdown'

import { SET_SECOND_INTERVIEW_QUESTIONS } from '../../../store/types/jobPosting'

const SecondInterviewQuestions = () => {
  const { second_interview_questions } = useSelector(
    (state) => state.jobPosting
  )
  const dispatch = useDispatch()

  const [secondInterviewOptions, setSecondInterviewOptions] = useState([])
  const [secondInterviewFieldError, setSecondInterviewFieldError] = useState('')

  const loadSecondInterviewOptions = () => {
    // pre-fill if there are already selected questions
    const existingQualifications = localStorage.getItem('qualifications')
    if (existingQualifications) {
      const parsedQualifications = JSON.parse(existingQualifications)
      if (parsedQualifications.second_interview_questions) {
        dispatch({
          type: SET_SECOND_INTERVIEW_QUESTIONS,
          payload: parsedQualifications.second_interview_questions,
        })
      }
    }

    axios
      .get(`${baseUrl}/rating-questions/second-interview`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('recruiterToken')}`,
        },
      })
      .then((response) => {
        const data = response.data.resp

        if (data) {
          const questions = data.map((item) => ({
            label: item.question,
            value: item.id,
          }))
          setSecondInterviewOptions(questions)
        }
      })
  }

  const handleSecondInterviewQuestions = (newValue) => {
    // get the last item from newValue
    const lastItem = newValue[newValue.length - 1]

    if (!newValue.length) return

    if (lastItem?.label === lastItem?.value) lastItem.isNew = true

    if (newValue.length > 5) {
      setSecondInterviewFieldError('You can add up to 5 questions only')
      // Keep only the first 5 already selected

      dispatch({
        type: SET_SECOND_INTERVIEW_QUESTIONS,
        payload: newValue.slice(0, 5),
      })
    } else {
      setSecondInterviewFieldError('')
      dispatch({ type: SET_SECOND_INTERVIEW_QUESTIONS, payload: newValue })
    }
  }

  useEffect(() => {
    loadSecondInterviewOptions()
  }, [])

  return (
    <CreatableSelectComponent
      id="second_interview_questions"
      title="Second Interview Questions"
      selected={second_interview_questions}
      options={secondInterviewOptions}
      onChange={handleSecondInterviewQuestions}
      placeholder="Type something and press enter..."
      wrapperClass={secondInterviewFieldError && 'error'}
      subText={secondInterviewFieldError}
    />
  )
}

export default SecondInterviewQuestions
